import React from 'react'

const PageTitle = ({ children }) => (
  <h1 className="inline-block w-full p-3 mb-20 text-2xl font-bold shadow-md bg-primary dark:bg-purple-900 text-white">
    {children}
  </h1>
)

export default PageTitle
